module.exports = __webpack_public_path__ + "static/media/img17.46b44c4e.jpg";